import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { DeleteSvg, EditSvg, SwitchOffSvg, SwitchOnSvg } from "../../assets/svg/index.js";
import * as UserActions from '../../redux/actions/userAction.js';
import MainDatatable from "../../components/common/MainDatatable.jsx";
import { Avatar, Dialog, DialogContent, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { CloseRounded } from "@mui/icons-material";
import logo_icon from '../../assets/images/logo_icon.png'
import { api_urls } from "../../utils/api-urls/index.js";

export const ListUsers = () => {
    const dispatch = useDispatch();
    const { userData: userData } = useSelector((state) => state?.userReducer);

    const [userModalVisible, setUserModalVisible] = useState(false)
    const [userDetails, setUserDetails] = useState({
        userId: '',
        firstName: '',
        lastName: '',
        email: '',
        contact: '',
        currentRole: '',
        password: '',
        userStatus: '',
        gender: '',
        education: '',
        income: '',
        maritalStatus: '',
        height: '',
        address: '',
        hobbies: [],
        country: '',
        state: '',
        city: '',
        isMilanSathiProfile: '',
        diet: ''
    });
    const [inputFieldError, setInputFieldError] = useState({ name: "Please Provide Name", email: "Please Provide Email" })
    const [image, setImage] = useState({ file: logo_icon, bytes: "" });

    //* Handle Input Field : Error
    const handleInputFieldError = (input, value) => {
        setInputFieldError((prev) => ({ ...prev, [input]: value }))
    }

    //* Handle Input Field : Data
    const handleInputField = (e) => {
        const { name, value } = e.target;
        setUserDetails({ ...userDetails, [name]: value });
    };

    //* Handle User Profile Image
    const handleimage = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setImage({
                file: URL.createObjectURL(e.target.files[0]),
                bytes: e.target.files[0],
            });
        }
    };

    //! Handle Edit - Setting User Data To Field : User 
    const handleEditUser = (data) => {
        setUserModalVisible(!userModalVisible)
        console.log("Edit Data ::: ", data)

        setUserDetails({
            userId: data._id || '',
            firstName: data.firstName || '',
            lastName: data.lastName || '',
            email: data.email || '',
            contact: data.phone || '',
            currentRole: data.currentRole || '',
            password: data.password || '',
            userStatus: data.userStatus || '',
            gender: data.gender || '',
            education: data.education || '',
            income: data.income || '',
            maritalStatus: data.maritalStatus || '',
            height: data.height || '',
            address: data.address || '',
            hobbies: data.hobbies || [],
            country: data.country || '',
            state: data.state || '',
            city: data.city || '',
            isMilanSathiProfile: data.isMilanSathiProfile || '',
            diet: data.diet || ''

        });

        setImage({
            file: api_urls + data?.profileImage || logo_icon
        })
    }

    //! Handle Submit - Creating User
    //! Handle Submit - Creating User
    const handleSubmit = async (e) => {
        e.preventDefault();

        const {
            userId,
            firstName,
            lastName,
            contact,
            email,
            currentRole,
            password,
            userStatus,
            gender,
            education,
            income,
            maritalStatus,
            height,
            address,
            hobbies,
            country,
            state,
            city,
            isMilanSathiProfile,
            diet
        } = userDetails;

        // Create a pure JSON object (no FormData)
        const payload = {
            userId,
            firstName,
            lastName,
            phone: contact,
            email,
            currentRole,
            password,
            userStatus,
            gender,
            education,
            income,
            maritalStatus,
            height,
            address,
            hobbies: Array.isArray(hobbies) ? hobbies : [],
            country,
            state,
            city,
            isMilanSathiProfile: Boolean(isMilanSathiProfile),
            diet
        };

        console.log("User Data (JSON) :: ", payload);

        // Basic validation
        if (!firstName || !lastName || !email) {
            alert("Please fill in all required fields");
            return;
        }

        // Dispatch your Redux action with JSON payload
        dispatch(UserActions.updateUser({
            data: payload,
            onComplete: () => {
                setUserModalVisible(false);
                // Reset form if needed
                setUserDetails({
                    userId: '',
                    firstName: '',
                    lastName: '',
                    email: '',
                    contact: '',
                    currentRole: '',
                    password: '',
                    userStatus: '',
                    gender: '',
                    education: '',
                    income: '',
                    maritalStatus: '',
                    height: '',
                    address: '',
                    hobbies: [],
                    country: '',
                    state: '',
                    city: '',
                    isMilanSathiProfile: '',
                    diet: ''
                });
                setImage({ file: logo_icon, bytes: "" });
            }
        }));
    };


    //* User DataTable Columns
    const userColumns = [
        { name: 'S.No.', selector: row => userData.indexOf(row) + 1, width: '80px' },
        { name: 'First Name', selector: row => row?.firstName, width: '180px' },
        { name: 'Last Name', selector: row => row?.lastName, width: '180px' },
        { name: 'Email', selector: row => row?.email, width: '200px' },
        { name: 'Mobile', selector: row => row?.phone, width: '110px' },
        { name: 'Address', selector: row => row?.address, },
        { name: 'City', selector: row => row?.city, width: '120px' },
        { name: 'State', selector: row => row?.state, width: '120px' },
        { name: 'Country', selector: row => row?.country, width: '100px' },
        // { name: 'Status', selector: row => row?.email_status ? row?.email_status : row?.mobile_status , width: '100px' },
        // { name: 'Profile', cell: row => <img src={row?.image} alt="Profile" style={{ width: '50px', height: '50px', borderRadius: '50%' }} />, width: '100px' },
        // { name: 'Status', selector: row => <div onClick={() => dispatch(UserActions.changeUserStatus({ userId: row?._id }))} style={{ textTransform: "capitalize", cursor: "pointer" }}>{row?.userStatus == 'Active' ? <SwitchOnSvg /> : <SwitchOffSvg />}</div>, width: '100px' },
        {
            name: 'Action',
            cell: row => <div style={{ display: "flex", gap: "10px", alignItems: "center" }} >
                <div onClick={() => handleEditUser(row)} style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "4px", backgroundColor: "#e3f2fd", padding: "5px 10px", borderRadius: "5px", color: "#1565c0", fontSize: "12px", fontWeight: "600" }}>
                    <EditSvg /> Edit
                </div>
                <div onClick={() => dispatch(UserActions.deleteUser({ userId: row?._id }))} style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "4px", backgroundColor: "#ffebee", padding: "5px 10px", borderRadius: "5px", color: "#c62828", fontSize: "12px", fontWeight: "600" }}>
                    <DeleteSvg /> Delete
                </div>
            </div>, width: '220px'
        },
    ];

    useEffect(function () {
        //! Dispatching API for Getting User
        dispatch(UserActions.getUser())
    }, []);

    return (
        <>
            <MainDatatable data={userData} columns={userColumns} title={'List of Users'} />
            {/* url={'/add-user'} */}

            <Dialog open={userModalVisible}>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item lg={12} sm={12} md={12} xs={12} sx={{ marginBottom: "20px" }}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <div style={{ fontSize: "23px", fontWeight: "600" }}>Edit User</div>
                                <div onClick={() => setUserModalVisible(false)}><CloseRounded /></div>
                            </div>
                        </Grid>

                        {/* Profile Image */}
                        {/* <Grid item lg={12} sm={12} md={12} xs={12}>
                            <div style={{ display: "flex", alignItems: "center", gap: "20px", marginBottom: "20px" }}>
                                <Avatar
                                    src={image.file}
                                    style={{ width: 60, height: 60 }}
                                />
                                <div>
                                    <input
                                        onChange={handleimage}
                                        accept="image/*"
                                        type="file"
                                        style={{ display: "none" }}
                                        id="profile-image-upload"
                                    />
                                    <label htmlFor="profile-image-upload">
                                        <div style={{
                                            fontWeight: "500",
                                            backgroundColor: "#164E62",
                                            color: "#fff",
                                            padding: "10px 20px",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                            textAlign: "center"
                                        }}>
                                            Change Profile Image
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </Grid> */}

                        {/* Basic Information */}
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <TextField
                                label="First Name"
                                variant='outlined'
                                fullWidth
                                name='firstName'
                                value={userDetails?.firstName}
                                onChange={handleInputField}
                                required
                            />
                        </Grid>

                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <TextField
                                label="Last Name"
                                variant='outlined'
                                fullWidth
                                name='lastName'
                                value={userDetails?.lastName}
                                onChange={handleInputField}
                                required
                            />
                        </Grid>

                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <TextField
                                label="Email"
                                variant='outlined'
                                fullWidth
                                name='email'
                                value={userDetails?.email}
                                onChange={handleInputField}
                                required
                                type="email"
                            />
                        </Grid>

                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <TextField
                                label="Contact"
                                variant='outlined'
                                fullWidth
                                name='contact'
                                value={userDetails?.contact}
                                onChange={handleInputField}
                            />
                        </Grid>

                        {/* Personal Details */}
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <FormControl fullWidth>
                                <InputLabel>Gender</InputLabel>
                                <Select
                                    label="Gender"
                                    variant="outlined"
                                    fullWidth
                                    name='gender'
                                    value={userDetails?.gender}
                                    onChange={handleInputField}
                                >
                                    <MenuItem value="">Select Gender</MenuItem>
                                    <MenuItem value="male">Male</MenuItem>
                                    <MenuItem value="female">Female</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <FormControl fullWidth>
                                <InputLabel>Marital Status</InputLabel>
                                <Select
                                    label="Marital Status"
                                    variant="outlined"
                                    fullWidth
                                    name='maritalStatus'
                                    value={userDetails?.maritalStatus}
                                    onChange={handleInputField}
                                >
                                    <MenuItem value="">Select Marital Status</MenuItem>
                                    <MenuItem value="unmarried">Unmarried</MenuItem>
                                    <MenuItem value="divorced">Divorced</MenuItem>
                                    <MenuItem value="widowed">Widowed</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <TextField
                                label="Education"
                                variant='outlined'
                                fullWidth
                                name='education'
                                value={userDetails?.education}
                                onChange={handleInputField}
                            />
                        </Grid>

                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <TextField
                                label="Income"
                                variant='outlined'
                                fullWidth
                                name='income'
                                value={userDetails?.income}
                                onChange={handleInputField}
                            />
                        </Grid>

                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <TextField
                                label="Height"
                                variant='outlined'
                                fullWidth
                                name='height'
                                value={userDetails?.height}
                                onChange={handleInputField}
                                placeholder="e.g., 5'8''"
                            />
                        </Grid>

                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <TextField
                                label="Diet"
                                variant='outlined'
                                fullWidth
                                name='diet'
                                value={userDetails?.diet}
                                onChange={handleInputField}
                                placeholder="e.g., Vegetarian, Non-Vegetarian"
                            />
                        </Grid>

                        {/* Address Information */}
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <TextField
                                label="Address"
                                variant='outlined'
                                fullWidth
                                name='address'
                                value={userDetails?.address}
                                onChange={handleInputField}
                                multiline
                                rows={2}
                            />
                        </Grid>

                        <Grid item lg={4} md={4} sm={12} xs={12}>
                            <TextField
                                label="City"
                                variant='outlined'
                                fullWidth
                                name='city'
                                value={userDetails?.city}
                                onChange={handleInputField}
                            />
                        </Grid>

                        <Grid item lg={4} md={4} sm={12} xs={12}>
                            <TextField
                                label="State"
                                variant='outlined'
                                fullWidth
                                name='state'
                                value={userDetails?.state}
                                onChange={handleInputField}
                            />
                        </Grid>

                        <Grid item lg={4} md={4} sm={12} xs={12}>
                            <TextField
                                label="Country"
                                variant='outlined'
                                fullWidth
                                name='country'
                                value={userDetails?.country}
                                onChange={handleInputField}
                            />
                        </Grid>

                        {/* Hobbies */}
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <TextField
                                label="Hobbies (comma separated)"
                                variant='outlined'
                                fullWidth
                                name='hobbies'
                                value={Array.isArray(userDetails?.hobbies) ? userDetails.hobbies.join(', ') : userDetails?.hobbies}
                                onChange={(e) => {
                                    const hobbiesArray = e.target.value.split(',').map(hobby => hobby.trim()).filter(hobby => hobby);
                                    setUserDetails({ ...userDetails, hobbies: hobbiesArray });
                                }}
                                placeholder="e.g., Reading, Swimming, Traveling"
                            />
                        </Grid>

                        {/* Account Settings */}
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <TextField
                                label="Password"
                                variant='outlined'
                                fullWidth
                                name='password'
                                value={userDetails?.password}
                                onChange={handleInputField}
                                type="password"
                            />
                        </Grid>

                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <FormControl fullWidth>
                                <InputLabel>User Status</InputLabel>
                                <Select
                                    label="User Status"
                                    variant="outlined"
                                    fullWidth
                                    name='userStatus'
                                    value={userDetails?.userStatus}
                                    onChange={handleInputField}
                                >
                                    <MenuItem value="Active">Active</MenuItem>
                                    <MenuItem value="Inactive">Inactive</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* Milan Sathi Profile */}
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <FormControl fullWidth>
                                <InputLabel>Milan Sathi Profile</InputLabel>
                                <Select
                                    label="Milan Sathi Profile"
                                    variant="outlined"
                                    fullWidth
                                    name='isMilanSathiProfile'
                                    value={userDetails?.isMilanSathiProfile}
                                    onChange={handleInputField}
                                >
                                    <MenuItem value="true">Yes</MenuItem>
                                    <MenuItem value="false">No</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* Action Buttons */}
                        <Grid item lg={12} sm={12} md={12} xs={12}>
                            <Grid container spacing={2}>
                                <Grid item lg={6} sm={6} md={6} xs={6}>
                                    <div onClick={handleSubmit} style={{
                                        fontWeight: "500",
                                        backgroundColor: "#164E62",
                                        color: "#fff",
                                        padding: "10px 20px",
                                        borderRadius: "5px",
                                        cursor: "pointer",
                                        fontSize: "15px",
                                        textAlign: "center",
                                        fontFamily: "Philosopher"
                                    }}>
                                        Update User
                                    </div>
                                </Grid>
                                <Grid item lg={6} sm={6} md={6} xs={6}>
                                    <div onClick={() => setUserModalVisible(false)} style={{
                                        fontWeight: "500",
                                        backgroundColor: "#EDF2F5",
                                        color: "#000",
                                        padding: "10px 20px",
                                        borderRadius: "5px",
                                        cursor: "pointer",
                                        fontSize: "15px",
                                        textAlign: "center",
                                        fontFamily: "Philosopher"
                                    }}>
                                        Close
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default ListUsers;